import './styles/item-list.scss'

import React        from 'react'
import PropTypes    from 'prop-types'
import { connect }  from 'react-redux'
import { Link }     from 'react-router-dom'
import JobFilter    from '../job/JobFilter'
import NameFilter   from '../components/NameFilter'
import LogsFilter from '../components/LogsFilter'

import { Dimmer, Loader } from 'semantic-ui-react'

import DataSystemItem     from '../dataSystem/DataSystemItem'
import DataTypeItem       from '../dataType/DataTypeItem'
import DataSourceItem     from '../dataSource/DataSourceItem'
import IntegrationItem    from '../integration/IntegrationItem'
import HoldItem           from '../hold/HoldItem'
import MaintenanceItem    from '../maintenance/MaintenanceItem'
import MaintenanceTemplateItem from '../maintenance/MaintenanceTemplateItem'
import HoldToolbar        from '../hold/HoldToolbar'
import MaintenanceTemplatesToolbar from '../maintenance/MaintenanceTemplatesToolbar'
import JobItem            from '../job/JobItem'
import EndpointItem       from '../endpoint/EndpointItem'
import ScrollableItemList from './ScrollableItemList'
import UserListHeader     from '../users/UserListHeader'
import UserListItem       from '../users/UserListItem'
import LogItem            from '../logs/LogItem'

import api from '../redux/api'
import { setFilter } from '../redux/actions/items'
import { mapCategoryPaths } from '../routeUtils'
import Modal from './ModalComponent'

const PAGE_SIZE = 5

const categoryHeader = {
  users: UserListHeader,
}

const categoryRenderer = {
  dataSystems:              { component: DataSystemItem },
  dataTypes:                { component: DataTypeItem },
  integrations:             { component: IntegrationItem },
  holds:                    { component: HoldItem, noDetails: true },
  maintenance:              { component: MaintenanceItem, noDetails: true, noDataComponent: (
    <div>
      Currently there are no maintenances. To create a new maintenance, navigate to <Link to="/maintenance-templates">Maintenance Tamplates</Link> and start a new Maintenance Mode on an existing or new maintenance template
    </div>
  ) },
  maintenanceTemplates:     { component: MaintenanceTemplateItem, noDataComponent: (
    <div>
      Select <b>New Maintenance Template</b> button to create a new Maintenance Teamplte
    </div>
  ) },
  jobs:                     { component: JobItem },
  dataSources:              { component: DataSourceItem },
  endpoints:                { component: EndpointItem },
  gatewaySchedulerLogs:     { component: LogItem },
  batchDeliveryManagerLogs: { component: LogItem },
  users:                    { component: UserListItem, noDataComponent: (<p>There are no users yet. Select &#39;New User&#39; to start adding users</p>) },
}

const categoryFilter = {
  batchDeliveryManagerLogs: LogsFilter,
  gatewaySchedulerLogs:     LogsFilter,
  dataSystems:              NameFilter,
  dataTypes:                NameFilter,
  dataSources:              NameFilter,
  integrations:             NameFilter,
  jobs:                     JobFilter,
}

const categoryToolbar = {
  holds:                HoldToolbar,
  maintenanceTemplates: MaintenanceTemplatesToolbar,
}

class ItemList extends React.Component {
  static propTypes = {
    user:             PropTypes.object,
    data:             PropTypes.object.isRequired,
    history:          PropTypes.object.isRequired,
    filterCriteria:   PropTypes.object.isRequired,
    categories:       PropTypes.array.isRequired,
    selectedCategory: PropTypes.string.isRequired,
    setFilter:        PropTypes.func.isRequired,
  }

  state = {
    connection: null,
    error:false
  }

  componentDidMount() {
    this.handleCategoryChange(this.props.selectedCategory)
  }

  UNSAFE_componentWillReceiveProps = (props) => {    
    if (props.selectedCategory !== this.props.selectedCategory) {
      this.handleCategoryChange(props.selectedCategory)
    } else if (props.filterCriteria !== this.props.filterCriteria) {
      this.setState({ connection: null }, () => {
        this.loadData({ category: props.selectedCategory, filterCriteria: props.filterCriteria })
      })
    }
  }

  handleCategoryChange = (category) => {
    this.setState({ connection: null }, () => {
      this.loadData({ category, filterCriteria: this.props.filterCriteria })
    })
  }

  loadData = ({ category, startPosition, filterCriteria }) => {
    api.loadData({ category, count: PAGE_SIZE, startPosition, filterCriteria, user: this.props.user })
      .then((data) => {
        this.setState({ connection: data })
      })
      .catch((err) => {
        this.setState({error:true})
        console.log(err)
      })
  }

  handleLoadNextPage = async (cursor) => {
    const category = this.props.selectedCategory    
    return await api.loadData({ category, count: PAGE_SIZE, startPosition: cursor, filterCriteria: this.props.filterCriteria, user: this.props.user })
  }

  getCategoryItemRenderer = (node) => {
    const { selectedCategory, categories, history } = this.props    

    const rendererMetadata = categoryRenderer[selectedCategory]
    const renderer         = rendererMetadata && rendererMetadata.component
      ? React.createElement(rendererMetadata.component, { item: node, history })
      : `No renderer for category ${selectedCategory}`

    const categoryMap  = mapCategoryPaths(categories)
    const categoryPath = categoryMap[selectedCategory]

    return rendererMetadata.noDetails
      ? <div className="item-list-item">{renderer}</div>
      : <Link className="item-list-item" to={`/${categoryPath}/item/${node.id}`}>{renderer}</Link>
  }

  handleFilterChange = (filterConfig) => {
    this.props.setFilter(filterConfig)
  }

  render() {
    const { history, selectedCategory, filterCriteria } = this.props
    
    const { connection, error} = this.state

    const noDataComponent  = categoryRenderer[selectedCategory] && categoryRenderer[selectedCategory].noDataComponent
    const filterComponent  = categoryFilter[selectedCategory]
    const toolbarComponent = categoryToolbar[selectedCategory]

    const filter = filterComponent && React.createElement(filterComponent, {
      onFilterChange: this.handleFilterChange,
      selectedCategory, 
      filterCriteria,
    })

    const toolbar = toolbarComponent && React.createElement(toolbarComponent, { history })

    return (
      <div className="item-list">
        { filter }
        { toolbar }

        {
          error && (
            <Modal/>
          )
        }

        {
          !connection&& (
            <Dimmer active inverted>
              <Loader inverted>Loading</Loader>
            </Dimmer>
          )
        }

        { categoryHeader[selectedCategory] && React.createElement(categoryHeader[selectedCategory], { history }) }

        <div className="list-items">
          {
            connection && (
              <ScrollableItemList
                connection={connection}
                loadNextPage={this.handleLoadNextPage}
                renderNode={ (node) => this.getCategoryItemRenderer(node) }
                noDataComponent={noDataComponent}
              />  
            )
          }
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {
  setFilter,
}
const mapStateToProps = (state) => ({
  user:             state.auth.user,
  selectedCategory: state.items.selectedCategory,
  data:             state.items.data,
  categories:       state.items.categories,
  filteredItems:    state.items.filteredItems,
  filterCriteria:   state.items.filterCriteria,
})

export default connect(mapStateToProps, mapDispatchToProps)(ItemList)